module.exports = __webpack_public_path__ + "static/img/9周年.f2a495f4.jpg";